document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var mobileMenu = document.getElementById('mobileMenu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  // Toast helper
  var toast = document.getElementById('cartToast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  // AJAX add-to-cart for every product form on the page (cards + product page)
  document.querySelectorAll('form[action*="/cart/add"], form.product-form, .card form, form[data-type="add-to-cart-form"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Only intercept simple product forms (cards on home/shop); product page form can also use this
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            showToast(data.description || 'Could not add item to cart.');
            return;
          }
          showToast('Added to your bag');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (cart) updateCartCount(cart.item_count);
        })
        .catch(function () {
          showToast('Something went wrong — please try again.');
        });
    });
  });

  // Shop page filter buttons (filter by product type, client-side)
  var filters = document.getElementById('filters');
  var grid = document.getElementById('shopGrid');
  if (filters && grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    function draw(filter) {
      cards.forEach(function (card) {
        var show = filter === 'all' || card.dataset.collection === filter;
        card.style.display = show ? '' : 'none';
      });
    }
    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('.filter-btn');
      if (!btn) return;
      filters.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      draw(btn.dataset.filter);
    });
  }
});
